module.exports = __webpack_public_path__ + "static/media/receta-18.2a192faa.png";